import * as React from 'react';
import * as _ from 'lodash';
import { IGlobalSort } from '../../models/sorts';

export interface ISortProps<T> {
    sort: IGlobalSort<T>;
    sortGroupName: string;
    activeSortDirection?: number;
}

export interface ISortGroupProps<T> {
    sortGroupName: string;
    sorts: IGlobalSort<T>[];
    onSort?: (sort: IGlobalSort<T>) => void;
    customClasses?: string;
    sortLabel?: string;
}

export class SortGroup<T> extends React.Component<ISortGroupProps<T>, any> {
    static defaultProps = {
        onSort: (sort) => { },
        customClasses: ''
    }

    OnChange(newId: string) {
        let sort = _.find(this.props.sorts, (s) => s.sortId === newId);
        this.props.onSort(sort);
    }

    render() {
        const { sorts, sortGroupName, customClasses, sortLabel } = this.props;
        return (
            <div className={'global-sort'}>
                {sorts &&
                    <React.Fragment>
                        <span className="global-sort-label">{sortLabel}</span>
                        <select value={this.props.sorts.filter(x => x.selected)[0].sortId} onChange={(e) => this.OnChange(e.target.value)}>
                            {this.props.sorts.map((s, i) =>
                                <Sort
                                    key={s.sortId}
                                    sort={s}
                                    sortGroupName={sortGroupName}
                                />)}
                        </select>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export class Sort<T> extends React.Component<ISortProps<T>, any> {
    render() {
        const { sort } = this.props;

        return (
            <option value={sort.sortId}>{sort.display}</option>
        );
    }
}